<template>
  <div>
    <v-container class="px-0">
      <v-row no-gutters>
        <v-col cols="8" class="px-2">
          <v-card class="mx-auto" outlined>
            <div class="overline mx-4 my-3">Logs</div>

            <transition name="slide-fade" mode="out-in">
              <div class="graph-loader">
                <scale-loader
                  v-if="isChartLoading"
                  color="#2f3570"
                  height="20px"
                ></scale-loader>
              </div>
            </transition>

            <div>
              <md-tabs md-alignment="centered" @md-changed="tabChanged">
                <md-tab id="tab-snapshot" md-label="Snapshot">
                  <div class="week-selector">
                    <md-field>
                      <label for="week">Week</label>
                      <md-select v-model="selectedWeek" name="week" id="week">
                        <md-option
                          v-for="item in chartWeeksOptions"
                          :key="'weekOption' + item.value"
                          :value="item.value"
                          >{{ item.label }}</md-option
                        >
                      </md-select>
                    </md-field>

                    <md-button
                      class="md-icon-button md-raised"
                      :disabled="isFirstOption"
                      @click="prevOption"
                    >
                      <md-icon>keyboard_arrow_left</md-icon>
                    </md-button>
                    <md-button
                      class="md-icon-button md-raised"
                      :disabled="isLastOption"
                      @click="nextOption"
                    >
                      <md-icon>keyboard_arrow_right</md-icon>
                    </md-button>
                  </div>

                  <input
                    type="number"
                    class="custom-axis-input"
                    v-model="chartAxis"
                    @change="updateChartAxis"
                    v-if="isThereOutcomes"
                  />

                  <transition name="slide-fade" mode="out-in">
                    <template v-if="isThereOutcomes">
                      <snapshot-chart
                        :styles="bgChartStyle"
                        :chart-data="chartSnapshotData"
                        :chart-axis="chartAxis"
                      />
                    </template>
                    <md-empty-state
                      md-icon="hourglass_empty"
                      md-label="No weekly data"
                      md-description="There is no weekly analysis data for that week. This data must be sent by the algorithm so it is normal if the current week has no weekly data yet."
                      v-else
                    >
                    </md-empty-state>
                  </transition>
                </md-tab>
                <md-tab id="tab-7days" md-label="7 Days">
                  <div class="week-selector">
                    <md-field>
                      <label for="week">Week</label>
                      <md-select v-model="selectedWeek" name="week" id="week">
                        <md-option
                          v-for="item in chartWeeksOptions"
                          :key="'weekOption' + item.value"
                          :value="item.value"
                          >{{ item.label }}</md-option
                        >
                      </md-select>
                    </md-field>

                    <md-button
                      class="md-icon-button md-raised"
                      :disabled="isFirstOption"
                      @click="prevOption"
                    >
                      <md-icon>keyboard_arrow_left</md-icon>
                    </md-button>
                    <md-button
                      class="md-icon-button md-raised"
                      :disabled="isLastOption"
                      @click="nextOption"
                    >
                      <md-icon>keyboard_arrow_right</md-icon>
                    </md-button>
                  </div>

                  <div
                    v-for="(item, key, index) in chart7daysData"
                    v-bind:key="'chart7days-' + key"
                    class="chart7days-row"
                  >
                    <div class="chart7days-date caption">
                      {{ key | moment("ddd, MMM. Do") }}
                    </div>
                    <div class="dayChart7days">
                      <day-chart
                        :styles="bgChartStyle"
                        :chart-data="item"
                        view-type="day"
                        :hide-x-axis="index < 6"
                      />
                    </div>
                    <daily-outcome :date="key" />
                  </div>
                </md-tab>
                <md-tab id="tab-overview" md-label="Overview">
                  <div class="week-selector">
                    <div class="md-layout-item md-size-20">
                      <md-field>
                        <label for="viewType">Graph Type</label>
                        <md-select
                          v-model="viewType"
                          name="viewType"
                          id="viewType"
                        >
                          <md-option
                            v-for="item in viewTypesOptions"
                            :key="'viewTypeOption' + item.value"
                            :value="item.value"
                            >{{ item.label }}</md-option
                          >
                        </md-select>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-50">
                      <md-field v-if="viewType == 'week'">
                        <label for="week">Week</label>
                        <md-select v-model="selectedWeek" name="week" id="week">
                          <md-option
                            v-for="item in chartWeeksOptions"
                            :key="'weekOption' + item.value"
                            :value="item.value"
                            >{{ item.label }}</md-option
                          >
                        </md-select>
                      </md-field>
                      <md-datepicker
                        v-model="selectedDay"
                        md-immediately
                        :md-disabled-dates="disabledDates"
                        v-else
                      />
                    </div>
                    <div class="md-layout-item md-size-20">
                      <md-button
                        class="md-icon-button md-raised"
                        :disabled="isFirstOption"
                        @click="prevOption"
                      >
                        <md-icon>keyboard_arrow_left</md-icon>
                      </md-button>
                      <md-button
                        class="md-icon-button md-raised"
                        :disabled="isLastOption"
                        @click="nextOption"
                      >
                        <md-icon>keyboard_arrow_right</md-icon>
                      </md-button>
                    </div>
                  </div>

                  <input
                    type="number"
                    class="custom-axis-input"
                    v-model="chartAxisOverview"
                    @change="updateChartAxisOverview"
                  />

                  <bg-chart
                    :styles="bgChartStyle"
                    :chart-data="bgData"
                    :view-type="viewType"
                    :chart-axis="chartAxisOverview"
                  />
                </md-tab>
                <md-tab id="tab-notes" md-label="Notes">
                  <div class="week-selector">
                    <md-field>
                      <label for="week">Week</label>
                      <md-select v-model="selectedWeek" name="week" id="week">
                        <md-option
                          v-for="item in chartWeeksOptions"
                          :key="'weekOption' + item.value"
                          :value="item.value"
                          >{{ item.label }}</md-option
                        >
                      </md-select>
                    </md-field>

                    <md-button
                      class="md-icon-button md-raised"
                      :disabled="isFirstOption"
                      @click="prevOption"
                    >
                      <md-icon>keyboard_arrow_left</md-icon>
                    </md-button>
                    <md-button
                      class="md-icon-button md-raised"
                      :disabled="isLastOption"
                      @click="nextOption"
                    >
                      <md-icon>keyboard_arrow_right</md-icon>
                    </md-button>
                  </div>

                  <transition name="slide-fade" mode="out-in">
                    <div v-if="!isChartLoading && currentWeekLogs">
                      <participant-notes :logs="currentWeekLogs" />
                    </div>
                  </transition>
                </md-tab>
              </md-tabs>
            </div>
          </v-card>
        </v-col>
        <v-col cols="4" class="px-2">
          <v-card class="mx-auto" outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-4">{{ currentOutcomesLabel }}</div>
                <v-list-item-title class="headline mb-1"
                  >Outcomes</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>

            <transition name="slide-fade" mode="out-in">
              <div v-if="isThereOutcomes">
                <v-list>
                  <v-divider></v-divider>

                  <v-list-item class="mt-2">
                    <v-list-item-title>% in target</v-list-item-title>

                    <v-list-item-title class="text-right display-2">
                      {{ formatOutcome(currentOutcomes.timeInRange) }}
                      <span class="caption">%</span>
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-subtitle>% &lt;3.9</v-list-item-subtitle>

                    <v-list-item-title class="text-right font-weight-bold">
                      {{ formatOutcome(currentOutcomes.timeInHypo) }}
                      <span class="caption">%</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-subtitle>% &gt;10.0</v-list-item-subtitle>
                    <v-list-item-title class="text-right font-weight-bold">
                      {{ formatOutcome(currentOutcomes.timeInHyper) }}
                      <span class="caption">%</span>
                    </v-list-item-title>
                  </v-list-item>

                  <v-divider></v-divider>

                  <v-list-item>
                    <v-list-item-title>Bolus insulin</v-list-item-title>
                    <v-list-item-title class="text-right font-weight-bold">
                      {{ formatOutcome(currentOutcomes.bolusInsulin) }}
                      <span class="caption">U/day</span>
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item class="smaller-list-item">
                    <v-list-item-subtitle
                      >Meal insulin (carbs)</v-list-item-subtitle
                    >
                    <v-list-item-title class="text-right font-weight-bold">
                      {{ formatOutcome(currentOutcomes.mealBolusInsulin) }}
                      <span class="caption">U/day</span> ({{
                        formatOutcome(currentOutcomes.carbs)
                      }}
                      <span class="caption">g/day</span>)
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item class="smaller-list-item">
                    <v-list-item-subtitle>Basal insulin</v-list-item-subtitle>
                    <v-list-item-title class="text-right font-weight-bold">
                      {{ formatOutcome(currentOutcomes.basalInsulin) }}
                      <span class="caption">U/day</span>
                    </v-list-item-title>
                  </v-list-item>

                  <v-divider class="mt-2"></v-divider>

                  <v-list-item>
                    <v-list-item-title class="font-weight-bold"
                      >Compliance</v-list-item-title
                    >
                  </v-list-item>

                  <v-list-item class="smaller-list-item">
                    <v-list-item-title
                      >No. of missing data warnings</v-list-item-title
                    >
                    <v-list-item-title class="text-right font-weight-bold">
                      {{ currentWarningsNb }}
                      <span class="caption">notifs</span>
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item class="smaller-list-item">
                    <v-list-item-title
                      >% sensor usage (scans/day)</v-list-item-title
                    >
                    <v-list-item-title class="text-right font-weight-bold">
                      {{ formatOutcome(currentOutcomes.timeInSensor) }}
                      <span class="caption">%</span> ({{
                        formatOutcome(currentOutcomes.scansPerDay)
                      }})
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item class="smaller-list-item">
                    <v-list-item-title>App usage</v-list-item-title>
                    <v-list-item-title class="text-right font-weight-bold">
                      {{ formatOutcome(currentOutcomes.logsPerDay) }}
                      <span class="caption">logs/day</span>
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item class="smaller-list-item">
                    <v-list-item-title>No. of overrides (%)</v-list-item-title>
                    <v-list-item-title class="text-right font-weight-bold">
                      {{ formatOutcome(currentOutcomes.overridesNum) }}
                      ({{ formatOutcome(currentOutcomes.overridesPercent) }}
                      <span class="caption">%</span>)
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item class="smaller-list-item">
                    <v-list-item-title
                      >No. of retrospective logs (%)</v-list-item-title
                    >
                    <v-list-item-title class="text-right font-weight-bold">
                      {{ formatOutcome(currentOutcomes.manualBolusNum) }}
                      ({{ formatOutcome(currentOutcomes.manualBolusPercent) }}
                      <span class="caption">%</span>)
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </div>
              <md-empty-state
                md-icon="hourglass_empty"
                :md-label="`No ${viewType == 'week' ? 'weekly' : 'daily'} data`"
                md-description="There is no outcomes data for that week/day. This data must be sent by the algorithm so it is normal if the current week does not have weekly data yet."
                v-else
              >
              </md-empty-state>
            </transition>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style scoped>
.md-card-header {
  padding-bottom: 0px;
}
.md-tab {
  min-height: 500px;
}
.chart-container-bg {
  height: 500px;
}
.chart-container-snapshot {
  height: 400px;
}

.chart7days-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.chart7days-date {
  width: 110px;
  text-align: right;
  margin-right: 10px;
}
.dayChart7days {
  flex: 1;
  height: 80px;
}
#tab-7days > .chart7days-row:last-child > .dayChart7days {
  height: 100px;
}

.week-selector {
  display: flex;
  justify-content: space-between;
}
.week-selector > div {
  margin: 0 10px 20px;
}
.graph-loader {
  position: absolute;
  height: 30px;
  top: 10px;
  right: 10px;
}

.smaller-list-item {
  min-height: 30px;
}

.custom-axis-input {
  position: absolute;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  z-index: 2;
  font-size: 14px;
  width: 45px;
  text-align: right;
  margin-top: -10px;
  border-radius: 5px;
  cursor: pointer;
  outline: none;
}
</style>

<script>
import moment from "moment";
import { EventBus } from "../main";
import { decodeGraphDataKey, encodeGraphDataKey } from "../globals";
import BgChart from "../components/BgChart";
import DayChart from "../components/DayChart";
import SnapshotChart from "../components/SnapshotChart";
import DailyOutcome from "../components/DailyOutcome";
import ParticipantNotes from "../components/ParticipantNotes";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";

const fb = require("../firebaseConfig.js");

import { mapState } from "vuex";

export default {
  name: "history-chart",
  components: {
    BgChart,
    DayChart,
    SnapshotChart,
    ScaleLoader,
    DailyOutcome,
    ParticipantNotes
  },
  props: ["study", "params", "paramsArray"],
  data: () => ({
    selectedWeek: null,
    selectedDay: moment().format("YYYY-MM-DD"),
    isLastOption: true,
    isFirstOption: false,
    viewType: "week",
    viewTypesOptions: [
      { label: "Weekly", value: "week" },
      { label: "Daily", value: "day" }
    ],
    chartWeeksOptions: [],
    isChartLoading: false,
    bgChartStyle: {
      position: "relative",
      height: "100%"
    },
    dataArrayByDate: [],

    bgData: {
      labels: [],
      datasets: []
    },
    chartSnapshotData: {
      labels: [],
      datasets: []
    },
    chart7daysData: {},
    chartAxis: 22,
    chartAxisOverview: 22,
    currentWeekLogs: null,
    currentWarningsNb: 0
  }),
  computed: {
    ...mapState(["currentStudy", "currentGraphData", "currentWeekStart"]),
    isThereOutcomes: function() {
      let dayData;
      if (this.viewType === "week") {
        dayData = this.dataArrayByDate.find(
          data => data.date === this.selectedWeek
        );
      } else {
        dayData = this.dataArrayByDate.find(
          data => data.date === this.selectedDay
        );
      }
      return (
        dayData &&
        (this.viewType === "week" ? dayData.weeklyData : dayData.dailyData)
      );
    },
    currentOutcomes: function() {
      let outcomesData;
      if (this.isThereOutcomes) {
        let dataDate =
          this.viewType === "week" ? this.selectedWeek : this.selectedDay;
        let dayData = this.dataArrayByDate.find(data => data.date === dataDate);
        outcomesData =
          this.viewType === "week"
            ? { ...dayData.weeklyData }
            : { ...dayData.dailyData };
      }
      return outcomesData;
    },
    currentOutcomesLabel: function() {
      let label;
      if (this.viewType === "week") {
        label = this.chartWeeksOptions.find(
          week => week.value === this.selectedWeek
        )
          ? this.chartWeeksOptions.find(
              week => week.value === this.selectedWeek
            ).label
          : null;
      } else {
        label = moment(this.selectedDay).format("MMMM Do");
      }
      return label;
    }
  },
  watch: {
    viewType: async function(val) {
      let date = val == "week" ? this.selectedWeek : this.selectedDay;
      this.disablePrevNext(val, date);

      this.isChartLoading = true;
      await this.loadDataByWeek(date, val === "day");

      this.updateGraph(val, date);
    },
    selectedWeek: async function(val) {
      this.disablePrevNext(this.viewType, val);

      this.isChartLoading = true;
      await this.loadDataByWeek(val);

      this.updateSnapshotGraph(val);
      this.update7daysGraph(val);
      this.updateGraph(this.viewType, val);
    },
    selected7daysWeek: function(val) {
      this.update7daysGraph(val);
    },
    selectedDay: async function(val) {
      if (val) {
        this.disablePrevNext(this.viewType, val);

        this.isChartLoading = true;
        await this.loadDataByWeek(val, true);

        this.updateGraph(this.viewType, val);
      } else {
        this.isLastOption = true;
        this.isFirstOption = true;
      }
    },
    selectedSnapshotWeek: function(val) {
      this.updateSnapshotGraph(val);
    },
    currentGraphData: function(val) {
      this.setCurrentGraphData(val);
    }
  },
  created() {
    this.setChartWeekOptions();
  },
  mounted() {
    if (this.currentGraphData) {
      this.setCurrentGraphData(this.currentGraphData);
    }
  },

  methods: {
    async setCurrentGraphData(data) {
      if (data === "none") {
        this.selectedWeek = this.currentWeekStart;
      } else {
        let key = decodeGraphDataKey(Object.keys(data)[0]);

        if (this.chartWeeksOptions.find(week => week.value === key)) {
          this.selectedWeek = key;
        } else {
          this.selectedWeek = this.currentWeekStart;
        }
      }
    },
    setChartWeekOptions() {
      let dateCursor = moment(this.currentWeekStart);

      for (let i = 0; i < 10; i++) {
        let toDate = moment(dateCursor).add(6, "d");
        let label =
          dateCursor.format("MMMM Do") + " to " + toDate.format("MMMM Do");
        let value = dateCursor.format("YYYY-MM-DD");
        this.chartWeeksOptions.push({ label, value });

        dateCursor.subtract(7, "d");
      }
    },

    async loadDataByWeek(weekStart, singleDay) {
      const studyId = this.currentStudy.id;
      const loopFor = singleDay ? 1 : 7;
      let dateCursor = moment(weekStart, "YYYY-MM-DD");
      let returnData = [];
      let logsPromises = [];
      let bgDataPromises = [];
      let notificationsPromises = [];

      for (let i = 0; i < loopFor; i++) {
        let currentDate = dateCursor.format("YYYY-MM-DD");
        if (
          this.dataArrayByDate.findIndex(data => data.date === currentDate) < 0
        ) {
          let fromDate = moment(currentDate, "YYYY-MM-DD")
            .startOf("day")
            .toISOString()
            .replace(/\.[0-9]{3}/, ''); // Remove millis to query BgData by key
          let toDate = moment(currentDate, "YYYY-MM-DD")
            .endOf("day")
            .toISOString()
            .replace(/\.[0-9]{3}/, ''); // Remove millis to query BgData by key

          returnData.push({ date: currentDate });
          logsPromises.push(
            fb.LogsRef.child(studyId)
              .orderByChild("timestamp")
              .startAt(fromDate)
              .endAt(toDate)
              .once("value")
          );
          bgDataPromises.push(
            fb.BgDataRef.child(studyId)
              .orderByKey()
              .startAt(fromDate)
              .endAt(toDate)
              .once("value")
          );
          notificationsPromises.push(
            fb.NotificationsLogsRef.child(studyId)
              .orderByKey()
              .startAt(
                moment(fromDate)
                  .unix()
                  .toString()
              )
              .endAt(
                moment(toDate)
                  .unix()
                  .toString()
              )
              .once("value")
          );
          console.log(`${currentDate} Loading...`);
        } else {
          console.log(`${currentDate} Already loaded!`);
        }
        dateCursor.add(1, "d");
      }

      await Promise.all(logsPromises).then(values => {
        values.forEach((snap, index) => {
          returnData[index]["logs"] = snap.val();
        });
      });
      await Promise.all(bgDataPromises).then(values => {
        values.forEach((snap, index) => {
          returnData[index]["bgData"] = snap.val();
        });
      });
      await Promise.all(notificationsPromises).then(values => {
        values.forEach((snap, index) => {
          returnData[index]["notifs"] = snap.val();
        });
      });

      if (
        !singleDay &&
        this.dataArrayByDate.findIndex(data => data.date === weekStart) < 0
      ) {
        const formattedDate = encodeGraphDataKey(weekStart);
        const snapWeeklyData = await fb.GraphDataWeeklyRef.child(studyId)
          .child(formattedDate)
          .once("value");
        returnData[0]["weeklyData"] = snapWeeklyData.val();
      }

      if (singleDay) {
        let existingData = this.dataArrayByDate.find(
          data => data.date === weekStart
        );
        if (existingData && "dailyData" in existingData) {
          // Daily data already loaded
        } else {
          // Load daily data here
          const formattedDate = encodeGraphDataKey(weekStart);
          const snapDailyData = await fb.GraphDataDailyRef.child(studyId)
            .child(formattedDate)
            .once("value");

          if (existingData) {
            existingData["dailyData"] = snapDailyData.val();
          } else {
            returnData[0]["dailyData"] = snapDailyData.val();
          }
        }
      }

      const currentArr = this.dataArrayByDate;
      this.dataArrayByDate = [...currentArr, ...returnData];
      return true;
    },

    async updateGraph(viewType, startingDate) {
      let fromDate = moment(startingDate)
        .startOf("day")
        .toISOString();
      let toDate;
      if (viewType == "week") {
        toDate = moment(startingDate)
          .add(6, "d")
          .endOf("day")
          .toISOString();
      } else {
        toDate = moment(startingDate)
          .endOf("day")
          .toISOString();
      }

      this.bgData = { datasets: [], labels: [] };
      this.bgData = this.generateChartData(fromDate, toDate, viewType);

      EventBus.$emit("updateChartOverview");
      this.isChartLoading = false;
    },
    async update7daysGraph(startingDate) {
      this.chart7daysData = {};
      let dateCursor = moment(startingDate, "YYYY-MM-DD");
      for (let i = 0; i < 7; i++) {
        this.chart7daysData[
          dateCursor.format("YYYY-MM-DD")
        ] = this.generateChartData(
          dateCursor.startOf("day").toISOString(),
          dateCursor.endOf("day").toISOString(),
          "day",
          true
        );
        dateCursor.add(1, "d");
      }

      this.isChartLoading = false;
    },
    generateChartData(fromDate, toDate, viewType, is7daysGraph = false) {
      let chartData = { datasets: [], labels: [] };

      let data_logs = {};
      let data_bg = {};
      let data_notifs = {};

      this.currentWeekLogs = [];
      let weekLogs = [];
      let warningsNb = 0;

      // Load data and Set Labels
      for (
        var m = moment(fromDate);
        m.isBefore(moment(toDate));
        m.add(1, "days")
      ) {
        const dayData = this.dataArrayByDate.find(
          data => data.date === m.format("YYYY-MM-DD")
        );
        Object.assign(data_logs, dayData.logs);
        Object.assign(data_bg, dayData.bgData);
        Object.assign(data_notifs, dayData.notifs);

        weekLogs = [...weekLogs, ...Object.values(dayData.logs || {})];
        warningsNb += dayData.notifs ? Object.keys(dayData.notifs).length : 0;

        chartData.labels.push(m.toDate());
      }

      this.currentWeekLogs = weekLogs;
      this.currentWarningsNb = warningsNb;

      if (viewType == "day") {
        chartData.labels.push(moment(toDate));
      } else {
        chartData.labels.push(moment(toDate).endOf("day"));
      }

      // BG Logs
      let dataset_bg_line = {
        yAxisID: "bg",
        type: "line",
        label: "Sensor",
        data: [],
        fill: false,
        backgroundColor: "#18264f",
        lineTension: 0.1,
        borderColor: "#18264f",
        pointRadius: is7daysGraph || viewType == "week" ? 0 : 2,
        borderWidth: 2
      };
      let latest = 0;
      for (let key in data_bg) {
        let log = data_bg[key];

        let diff = moment
          .duration(moment(key).diff(moment(latest)))
          .asMinutes();
        if (latest == 0) {
          diff = 0;
        }
        if (diff > 20) {
          dataset_bg_line.data.unshift({
            x: moment(key)
              .subtract(diff / 2, "m")
              .toISOString(),
            y: undefined
          });
        }

        dataset_bg_line.data.unshift({
          x: moment(key).toISOString(),
          y: log
        });
        latest = key;
      }

      // Notifications Logs
      let dataset_notifs = {
        yAxisID: "insulin",
        type: "line",
        label: "Notifications",
        data: [],
        fill: false,
        backgroundColor: ["#efa218"],
        borderColor: ["#efa218"],
        showLine: false,
        pointRadius: 7,
        pointHoverRadius: 9,
        pointStyle: "triangle"
      };
      for (let key in data_notifs) {
        let notif = data_notifs[key];
        if (notif.f === "notifyUserInactivity") {
          let color = "#efa218";
          if ("error" in notif) {
            color = "#c80022";
          }
          dataset_notifs.data.unshift({
            x: moment.unix(key).toISOString(),
            y: 40,
            success: !("error" in notif)
          });
          dataset_notifs.backgroundColor.unshift(color);
          dataset_notifs.borderColor.unshift(color);
        }
      }

      // Bolus Logs, separated datasets
      let ds_breakfast = {
        yAxisID: "insulin",
        label: "Breakfast",
        backgroundColor: ["#74b766"],
        borderColor: ["#74b766"],
        data: [],
        fill: false,
        barThickness: 7,
        borderWidth: 2
      };
      let ds_lunch = {
        yAxisID: "insulin",
        label: "Lunch",
        backgroundColor: ["#74b766"],
        borderColor: ["#74b766"],
        data: [],
        fill: false,
        barThickness: 7,
        borderWidth: 2
      };
      let ds_supper = {
        yAxisID: "insulin",
        label: "Dinner",
        backgroundColor: ["#74b766"],
        borderColor: ["#74b766"],
        data: [],
        fill: false,
        barThickness: 7,
        borderWidth: 2
      };
      let ds_bedtime = {
        yAxisID: "insulin",
        label: "Bedtime",
        backgroundColor: ["#74b766"],
        borderColor: ["#74b766"],
        data: [],
        fill: false,
        barThickness: 7,
        borderWidth: 2
      };
      let ds_corr = {
        yAxisID: "insulin",
        label: "Correction",
        backgroundColor: ["#f6b037"],
        borderColor: ["#f6b037"],
        data: [],
        fill: false,
        barThickness: 7,
        borderWidth: 2
      };

      let ds_log_points = {
        yAxisID: "insulin",
        type: "line",
        label: "",
        data: [],
        fill: false,
        backgroundColor: [],
        borderWidth: 0,
        pointRadius: 4,
        pointStyle: "circle",
        showLine: false,
        showTooltips: false
      };

      let dataset_bg_from_user = {
        yAxisID: "bg",
        type: "line",
        label: "BG",
        data: [],
        fill: false,
        backgroundColor: "#434ca0",
        pointRadius: 4,
        showLine: false
      };

      // Basal Logs
      let dataset_basal = {
        yAxisID: "insulin",
        type: "line",
        label: "Basal",
        data: [],
        fill: false,
        backgroundColor: "#335a2a",
        borderColor: [],
        borderWidth: 3,
        showLine: false,
        pointRadius: 7,
        pointHoverRadius: 9
      };

      // Note Logs
      let dataset_notes = {
        yAxisID: "insulin",
        type: "line",
        label: "Notes",
        data: [],
        fill: false,
        backgroundColor: "#1b1f40",
        borderColor: "#1b1f40",
        showLine: false,
        pointRadius: 7,
        pointHoverRadius: 9,
        pointStyle: "rectRot"
      };

      for (const log in Object.values(data_logs)) {
        if (log.type === "basal") {
          let borderColor = "#335a2a";
          if (log.userBasal !== log.basaDose) {
            borderColor = "#a13431";
          } else if (log.isCustomTimestamp) {
            borderColor = "#000000";
          }
          dataset_basal.data.unshift({
            x: moment(log.timestamp).toISOString(),
            y: log.userBasal > 44 ? 44 : log.userBasal,
            ...log
          });
          dataset_basal.borderColor.unshift(borderColor);
        } else if (log.type === "bolus") {
          let backgroundColor, borderColor;

          if (log.meal) {
            backgroundColor = "#74b766";
            borderColor = "#74b766";
            if (log.override) {
              borderColor = "#a13431";
            } else if (log.isCustomTimestamp) {
              borderColor = "#000000";
            }

            let current_ds_array = null;
            switch (log.meal) {
              case "breakfast":
                current_ds_array = ds_breakfast;
                break;
              case "lunch":
                current_ds_array = ds_lunch;
                break;
              case "supper":
                current_ds_array = ds_supper;
                break;
              case "bedtime":
                current_ds_array = ds_bedtime;
                break;
            }

            current_ds_array.data.unshift({
              x: moment(log.timestamp).toISOString(),
              y: log.bolusUser,
              ...log
            });
            current_ds_array.backgroundColor.unshift(backgroundColor);
            current_ds_array.borderColor.unshift(borderColor);
          } else {
            backgroundColor = "#f6b037";
            borderColor = "#f6b037";
            if (log.override) {
              borderColor = "#a13431";
            }

            if (log.bolusUser) {
              ds_corr.data.unshift({
                x: moment(log.timestamp).toISOString(),
                y: log.bolusUser,
                ...log
              });
              ds_corr.backgroundColor.unshift(backgroundColor);
              ds_corr.borderColor.unshift(borderColor);
            } else {
              console.log("Correction bolus but no bolus ???");
            }
          }

          if (log.bolusUser && Number(log.bolusUser) < 1) {
            ds_log_points.data.unshift({
              x: moment(log.timestamp).toISOString(),
              y: log.bolusUser,
              ...log
            });
            ds_log_points.backgroundColor.unshift(backgroundColor);
          }

          // Add manually entered BG
          if (log.bg && log.bg != "") {
            dataset_bg_from_user.data.unshift({
              x: moment(log.timestamp).toISOString(),
              y: log.bg
            });
          }
        } else if (log.type === "note") {
          dataset_notes.data.unshift({
            x: moment(log.timestamp).toISOString(),
            y: 36,
            ...log
          });
        }
      }

      // Update Chart
      chartData.datasets.push(dataset_bg_line);
      chartData.datasets.push(dataset_bg_from_user);
      chartData.datasets.push(ds_log_points);
      chartData.datasets.push(dataset_notifs);
      chartData.datasets.push(dataset_notes);
      chartData.datasets.push(dataset_basal);
      chartData.datasets.push(ds_breakfast);
      chartData.datasets.push(ds_lunch);
      chartData.datasets.push(ds_supper);
      chartData.datasets.push(ds_bedtime);
      chartData.datasets.push(ds_corr);

      return chartData;
    },

    async updateSnapshotGraph(weekStartDay) {
      let fromDate = moment(weekStartDay, "YYYY-MM-DD")
        .startOf("day")
        .toISOString();
      let toDate = moment(weekStartDay, "YYYY-MM-DD")
        .add(6, "days")
        .startOf("day")
        .toISOString();

      // Reset datasets
      this.chartSnapshotData.labels = [];
      this.chartSnapshotData.datasets = [];

      // Load data
      for (
        var m = moment(fromDate);
        m.isSameOrBefore(moment(toDate));
        m.add(1, "days")
      ) {
        const dayData = this.dataArrayByDate.find(
          data => data.date === m.format("YYYY-MM-DD")
        );

        let dataset_bg_line = {
          yAxisID: "bg",
          type: "line",
          label: m.format("MMM D"),
          data: [],
          fill: false,
          backgroundColor: "#cbd4ef",
          lineTension: 0.1,
          borderColor: "#cbd4ef",
          pointRadius: 0,
          borderWidth: 2,
          hidden: true
        };

        for (let key in dayData.bgData) {
          let log = dayData.bgData[key];
          let logDate = moment(key);
          let timeDate = moment();
          timeDate.hours(logDate.hours());
          timeDate.minutes(logDate.minutes());

          dataset_bg_line.data.unshift({
            x: timeDate.toISOString(),
            y: log
          });
        }

        this.chartSnapshotData.datasets.push(dataset_bg_line);
      }

      const weekStartDayData = this.dataArrayByDate.find(
        data => data.date === weekStartDay
      );
      if (weekStartDayData && weekStartDayData.weeklyData) {
        const weeklyData = weekStartDayData.weeklyData;

        let ds_weekly_median_glucose = {
          yAxisID: "bg",
          type: "line",
          label: "Median",
          data: weeklyData.medianGlucose,
          fill: false,
          backgroundColor: "#394088",
          lineTension: 0.1,
          borderColor: "#394088",
          pointRadius: 0,
          borderWidth: 2
        };
        this.chartSnapshotData.datasets.unshift(ds_weekly_median_glucose);

        let ds_weekly_mean_glucose = {
          yAxisID: "bg",
          type: "line",
          label: "Mean",
          data: weeklyData.meanGlucose,
          fill: false,
          backgroundColor: "#2f3570",
          lineTension: 0.1,
          borderColor: "#2f3570",
          pointRadius: 0,
          borderWidth: 5
        };
        this.chartSnapshotData.datasets.unshift(ds_weekly_mean_glucose);

        let ds_weekly_iqr3_glucose = {
          yAxisID: "bg",
          type: "line",
          label: "IQR3",
          data: weeklyData.iqr3Glucose,
          fill: "-1",
          backgroundColor: "rgba(48, 76, 156, 0.1)",
          lineTension: 0.1,
          borderColor: "#5059b5",
          pointRadius: 0,
          borderWidth: 2
        };
        this.chartSnapshotData.datasets.unshift(ds_weekly_iqr3_glucose);

        let ds_weekly_iqr1_glucose = {
          yAxisID: "bg",
          type: "line",
          label: "IQR1",
          data: weeklyData.iqr1Glucose,
          fill: false,
          backgroundColor: "rgba(48, 76, 156, 0.1)",
          lineTension: 0.1,
          borderColor: "#5059b5",
          pointRadius: 0,
          borderWidth: 2
        };
        this.chartSnapshotData.datasets.unshift(ds_weekly_iqr1_glucose);
      }

      // Set Labels
      for (let h = 0; h <= 24; h++) {
        for (let m = 0; m < 4; m++) {
          let timeDate = new Date();
          timeDate.setHours(h);
          timeDate.setMinutes(m * 15);
          this.chartSnapshotData.labels.push(timeDate.toISOString());
        }
      }

      EventBus.$emit("updateChartSnapshot");
      this.isChartLoading = false;
    },

    prevOption() {
      if (this.viewType == "week") {
        let weekIndex = this.chartWeeksOptions.findIndex(
          option => option.value === this.selectedWeek
        );
        this.selectedWeek = this.chartWeeksOptions[weekIndex + 1].value;
      } else {
        this.selectedDay = moment(this.selectedDay, "YYYY-MM-DD")
          .subtract(1, "d")
          .format("YYYY-MM-DD");
      }
    },
    nextOption() {
      if (this.viewType == "week") {
        let weekIndex = this.chartWeeksOptions.findIndex(
          option => option.value === this.selectedWeek
        );
        this.selectedWeek = this.chartWeeksOptions[weekIndex - 1].value;
      } else {
        this.selectedDay = moment(this.selectedDay, "YYYY-MM-DD")
          .add(1, "d")
          .format("YYYY-MM-DD");
      }
    },
    disablePrevNext(viewType, date) {
      if (viewType == "week") {
        let weekIndex = this.chartWeeksOptions.findIndex(
          option => option.value === date
        );
        this.isLastOption = weekIndex == 0;
        this.isFirstOption = weekIndex == this.chartWeeksOptions.length - 1;
      } else {
        this.isLastOption = moment(this.selectedDay, "YYYY-MM-DD").isAfter(
          moment().subtract(1, "d")
        );
        this.isFirstOption = false;
      }
    },
    disabledDates: date => {
      return moment(date).isAfter(moment());
    },
    updateChartAxis() {
      EventBus.$emit("updateChartAxis", Number(this.chartAxis));
    },
    updateChartAxisOverview() {
      EventBus.$emit("updateChartAxisOverview", Number(this.chartAxisOverview));
    },
    formatOutcome(value) {
      return value !== null && value !== undefined ? value.toFixed(1) : "";
    },
    tabChanged(tabId) {
      if (tabId !== "tab-overview") {
        this.viewType = "week";
      }
    }
  }
};
</script>
